import { BreakpointObserver } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';

@Injectable()
export class IsMobileService {
  constructor(private readonly breakPoint: BreakpointObserver) {}
  public isMobile$(maxWidth = 767): Observable<boolean> {
    return this.breakPoint
      .observe([`(max-width: ${maxWidth}px)`])
      .pipe(map((obs) => obs.breakpoints[`(max-width: ${maxWidth}px)`]));
  }
}
